import {IAppliedFilter} from 'plugins/modules/filter/helpers/BrowserFilters/AppliedFilters';
import {IFilterFacet, IFilterFacetVariant} from 'plugins/modules/filter/types';
import {useState, useCallback, useEffect} from 'react';

export const useOptimisticAppliedFilters = (appliedFilters: IAppliedFilter[]) => {
    const [optimisticFilters, setOptimisticFilters] = useState<IAppliedFilter[]>(appliedFilters);
    const [removedFilters, setRemovedFilters] = useState<Set<string>>(new Set());

    useEffect(() => {
        setOptimisticFilters(appliedFilters);
        setRemovedFilters(new Set());
    }, [appliedFilters]);

    const removeFilterOptimistically = useCallback((filter: IFilterFacet, variant?: IFilterFacetVariant) => {
        const filterKey = variant ? `${filter.code}-${variant.code}` : filter.code;

        setRemovedFilters((prev) => new Set(prev).add(filterKey));

        setOptimisticFilters((prev) =>
            prev.filter((item) => {
                if (variant) {
                    // singe filter
                    return !(item.filter.code === filter.code && item.variant?.code === variant.code);
                }
                // range filter
                return item.filter.code !== filter.code;
            }),
        );
    }, []);

    const getOptimisticFilters = useCallback(() => {
        return optimisticFilters;
    }, [optimisticFilters]);

    const isFilterRemoved = useCallback(
        (filter: IFilterFacet, variant?: IFilterFacetVariant) => {
            const filterKey = variant ? `${filter.code}-${variant.code}` : filter.code;
            return removedFilters.has(filterKey);
        },
        [removedFilters],
    );

    return {
        optimisticFilters: getOptimisticFilters(),
        removeFilterOptimistically,
        isFilterRemoved,
    };
};
